// extracted by mini-css-extract-plugin
export default {"auth-header":"AuthHeader_auth-header__lvXtP","auth-header__icon":"AuthHeader_auth-header__icon__o0omF"};